export default "__VITE_ASSET__bEsQG0af__"